/**
 * Clinical Overlays Index
 * 
 * All overlay components have been migrated to individual files.
 * Import from this file for clean imports.
 */

// All migrated overlay components
export { PhoneLogOverlay } from './PhoneLogOverlay';
export { ScheduleVisitOverlay } from './ScheduleVisitOverlay';
export { PainManagementOverlay } from './PainManagementOverlay';
export { VitalSignsOverlay } from './VitalSignsOverlay';
export { WoundCareOverlay } from './WoundCareOverlay';
export { IncidentReportOverlay } from './IncidentReportOverlay';
export { FamilyMessageOverlay } from './FamilyMessageOverlay';
export { DMESuppliesOverlay } from './DMESuppliesOverlay';
export { SymptomAssessmentOverlay } from './SymptomAssessmentOverlay';
export { ConsentFormsOverlay } from './ConsentFormsOverlay';
export { MedicationOverlay } from './MedicationOverlay';
export { CareCalendarOverlay } from './CareCalendarOverlay';
export { SymptomGuideOverlay } from './SymptomGuideOverlay';
export { RecertificationOverlay } from './RecertificationOverlay';
export { PhysicianOrdersOverlay } from './PhysicianOrdersOverlay';
export { PlanOfCareOverlay } from './PlanOfCareOverlay';
export { VisitFrequencyOverlay } from './VisitFrequencyOverlay';
export { PatientQuickSwitch } from './PatientQuickSwitch';
export { default as PrintPatientSummaryOverlay } from './PrintPatientSummaryOverlay';
export { IDGDiscussionOverlay } from './IDGDiscussionOverlay';

// New overlays for command palette integration
export { default as LCDEligibilityOverlay } from './LCDEligibilityOverlay';
export { default as AICarePlanOverlay } from './AICarePlanOverlay';
export { default as RCMManagementOverlay } from './RCMManagementOverlay';
export { default as StaffSchedulingOverlay } from './StaffSchedulingOverlay';
export { default as AcuityTrendsOverlay } from './AcuityTrendsOverlay';
export { default as VisitTemplateOverlay } from './VisitTemplateOverlay';
export { default as FallEventOverlay } from './FallEventOverlay';
export { default as FallRiskDashboardOverlay } from './FallRiskDashboardOverlay';
export { default as IDGVoiceMeetingOverlay } from './IDGVoiceMeetingOverlay';

// Overlay component mapping for dynamic rendering
export const OVERLAY_COMPONENTS = {
  phone_log: 'PhoneLogOverlay',
  schedule_visit: 'ScheduleVisitOverlay',
  pain_management: 'PainManagementOverlay',
  vital_signs: 'VitalSignsOverlay',
  wound_care: 'WoundCareOverlay',
  incident_report: 'IncidentReportOverlay',
  family_message: 'FamilyMessageOverlay',
  dme_supplies: 'DMESuppliesOverlay',
  symptom_assessment: 'SymptomAssessmentOverlay',
  consent_forms: 'ConsentFormsOverlay',
  medication: 'MedicationOverlay',
  care_calendar: 'CareCalendarOverlay',
  symptom_guide: 'SymptomGuideOverlay',
  recertification: 'RecertificationOverlay',
  physician_orders: 'PhysicianOrdersOverlay',
  plan_of_care: 'PlanOfCareOverlay',
  visit_frequency: 'VisitFrequencyOverlay',
  print_summary: 'PrintPatientSummaryOverlay',
  idg_discussion: 'IDGDiscussionOverlay',
};

// Component map for dynamic imports
export const OverlayComponents = {
  PhoneLogOverlay: () => import('./PhoneLogOverlay'),
  ScheduleVisitOverlay: () => import('./ScheduleVisitOverlay'),
  PainManagementOverlay: () => import('./PainManagementOverlay'),
  VitalSignsOverlay: () => import('./VitalSignsOverlay'),
  WoundCareOverlay: () => import('./WoundCareOverlay'),
  IncidentReportOverlay: () => import('./IncidentReportOverlay'),
  FamilyMessageOverlay: () => import('./FamilyMessageOverlay'),
  DMESuppliesOverlay: () => import('./DMESuppliesOverlay'),
  SymptomAssessmentOverlay: () => import('./SymptomAssessmentOverlay'),
  ConsentFormsOverlay: () => import('./ConsentFormsOverlay'),
  MedicationOverlay: () => import('./MedicationOverlay'),
  CareCalendarOverlay: () => import('./CareCalendarOverlay'),
  SymptomGuideOverlay: () => import('./SymptomGuideOverlay'),
  RecertificationOverlay: () => import('./RecertificationOverlay'),
  PhysicianOrdersOverlay: () => import('./PhysicianOrdersOverlay'),
  PlanOfCareOverlay: () => import('./PlanOfCareOverlay'),
  VisitFrequencyOverlay: () => import('./VisitFrequencyOverlay'),
  PatientQuickSwitch: () => import('./PatientQuickSwitch'),
  PrintPatientSummaryOverlay: () => import('./PrintPatientSummaryOverlay'),
  IDGDiscussionOverlay: () => import('./IDGDiscussionOverlay'),
};
